import { useCallback, useEffect, useState } from 'react';
import MsDyn365, { ICoreContext } from '@msdyn365-commerce/core';

export const useIsMobile = (context: ICoreContext) => {
    type GridSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    const { device, gridSettings } = context.request ?? {};

    const [isMobile, setIsMobile] = useState((device && device.Type === 'Mobile') || false);

    const getViewport = useCallback((): GridSize => {
        // Always render in mobile viewport on a mobile device
        if (device && device.Type === 'Mobile') {
            return 'xs';
        }

        if (MsDyn365.isBrowser && window.innerWidth) {
            if (gridSettings) {
                if (gridSettings.xs && window.innerWidth <= gridSettings.xs.w) {
                    return 'xs';
                } else if (gridSettings.sm && window.innerWidth <= gridSettings.sm.w) {
                    return 'sm';
                } else if (gridSettings.md && window.innerWidth <= gridSettings.md.w) {
                    return 'md';
                } else if (gridSettings.lg && window.innerWidth <= gridSettings.lg.w) {
                    return 'lg';
                }
                return 'xl';
            }
        }

        return 'xs';
    }, [device, gridSettings]);

    const updateIsMobile = useCallback(() => {
        const viewport = getViewport();
        setIsMobile(viewport === 'xs' || viewport === 'sm');
    }, [getViewport]);

    useEffect(() => {
        if (typeof window === 'undefined' || !window.addEventListener) {
            return undefined;
        }

        updateIsMobile();
        window.addEventListener('resize', updateIsMobile);

        return () => window.removeEventListener('resize', updateIsMobile);
    }, [updateIsMobile]);

    return isMobile;
};
